import { useMe } from './auth.tsx';
import type { Me } from './api.ts';

/** 권한 판단 (CR-025). me.permissions = 권한 키 → 범위(tenant|dept_tree|dept|own) */
export type Scope = 'tenant' | 'dept_tree' | 'dept' | 'own';
export const SCOPE_LABEL: Record<Scope, string> = { tenant: '전사', dept_tree: '부서+하위', dept: '소속 부서', own: '내 담당' };
export const can = (me: Me | null | undefined, perm: string) => !!me?.permissions?.[perm];
export const wide = (me: Me | null | undefined, perm: string) => me?.permissions?.[perm] === 'tenant';
export function usePerm() {
  const me = useMe();
  return { me: me.data, can: (perm: string) => can(me.data, perm), wide: (perm: string) => wide(me.data, perm), any: (...perms: string[]) => perms.some((p) => can(me.data, p)) };
}
